<template lang="pug">

div
  section.works.u-mt-md
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10
      .column
        h1 {{$t('pageTitle')}}
        p.u-text-lg {{$t('mantra')}}

  section.u-mt-md
    AppImg(:srcset="[{ srcset: '{CDN_URL}/brand/downloads/01@2x.jpg 2x, {CDN_URL}/brand/downloads/01.jpg 1x', type: 'image/jpg' }]" class="u-img" :imgAlt="$t('pageTitle')" ratio="5:2")

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-md(v-for="item in $t('downloadItems')")
        h4 {{item.title}}
        p {{item.desc}}
        .u-mt-xs
          AppLink(to="https://cdn.baianat.com/static/logo.zip" :title="$t('download')" class="button-link is-small ") {{$t('download')}}

</template>

<script>
export default {
  meta: {
    theme: 'base-home is-dark'
  },
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Brand Downloads",
    "pageDesc":"Baianat brand assets and resources needed when using our identity both online and offline.",
    "mantra":"Thanks for your interest in Baianat. We have a few guidelines for using our brand resources—please take a moment to familiarize yourself with them. Download all of our Brand Resources.",
    "download":"Download",
    "downloadItems":{
      "1":{
        "title":"Logo",
        "desc":"Baianat logo is the symbol that communicates our business clearly, First comes personality, then color."
      },
      "2":{
        "title":"Colors",
        "desc":"A color palette of mainly black and white, because we don't believe in gray space."
      },
      "3":{
        "title":"Stationary",
        "desc":"All the visual media of cards, pens, CDs, etc. to use according to our policy."
      },
      "4":{
        "title":"Visuals",
        "desc":"A collection of our different services imagery and other visual assets."
      },
      "5":{
        "title":"Advertising",
        "desc":"For any advertisement need of Baianat like folders and leaflets that can be used in printing or books."
      }
    }
  },
  "ar": {
    "pageTitle":"تحميلات العلامة التجارية لبيانات",
    "pageDesc":"يجب الحفاظ على أصول وموارد العلامة التجارية لشركة بيانات، عند استخدام هويتنا سواء عبر الإنترنت أو أوفلاين.",
    "mantra":"نشكرك لاهتمامك ببيانات. لدينا بعض الإرشادات حول استخدام موارد العلامة التجارية الخاصة بنا، نرجو منك أن تُخصص بعض الوقت للتعرُّف عليها. قم بتحميل جميع موارد العلامة التجارية الخاصة بنا. ",
    "download":"تحميل",
    "downloadItems":{
      "1":{
        "title":"الشعار",
        "desc":"شعار بيانات هو الرمز الذي ينقل عملنا بوضوح، تأتى الشخصية أولًا وبعدها الألوان. "
      },
      "2":{
        "title":"الألوان",
        "desc":"لوحة الألوان الأساسية لدينا بالأسود والأبيض، لأننا لا نؤمن بالمساحة الرمادية."
      },
      "3":{
        "title":"الأدوات المكتبية",
        "desc":"يمكنك استخدامها في جميع الوسائط المرئية للبطاقات والأقلام والأقراص المضغوطة وما إلى ذلك لاستخدامها وفقًا لسياستنا."
      },
      "4":{
        "title":"المرئيات",
        "desc":"مجموعة من صور الخدمات المختلفة والأصول المرئية الأخرى."
      },
      "5":{
        "title":"الإعلانات",
        "desc":"عند استخدام العلامة التجارية  لبيانات  في الإعلانات على سبيل المثال للمجلدات أو المنشورات التي يمكن استخدامها في الطباعة أو الكتب."
      }
    }
  }
}
</i18n>
